import { useState } from 'react';
import CloseGameDialog from '@/components/common/close-game-dialog';
import CompleteProfileDialog from '@/components/common/complete-profile-dialog';
import { useRouter } from '@/i18n/routing';
import { type GameResponseType } from '@/lib/fetch';
import { useAppStore } from '@/providers/AppStoreProvider';

const useCasinoGameClick = () => {
  const router = useRouter();

  const setIsQuickDepositOpen = useAppStore((state) => state.setIsQuickDepositOpen);
  const balance = useAppStore((state) => state.balance);

  const [showCompleteProfileDialog, setShowCompleteProfileDialog] = useState(false);
  const [showCloseGameDialog, setShowCloseGameDialog] = useState(false);

  const handleQuickDeposit = () => setIsQuickDepositOpen(true);

  const handleDemoPlay = (game: Pick<GameResponseType, 'id' | 'slug'>) => {
    return router.push({
      pathname: `/game/${game.id}/${game.slug}`,
      query: {
        mode: 'fun',
      },
    });
  };

  // In case user is authenticated the middleware with redirect to sign in page
  const handleRealPlay = (game: Pick<GameResponseType, 'id' | 'slug'>) => {
    if (balance === 0) {
      handleQuickDeposit();

      return;
    }

    return router.push({
      pathname: `/game/${game.id}/${game.slug}`,
      query: {
        mode: 'real',
      },
    });
  };

  const dialogsRenderer = () => (
    <>
      <CloseGameDialog
        handleOpen={setShowCloseGameDialog}
        open={showCloseGameDialog}
      />
      <CompleteProfileDialog
        open={showCompleteProfileDialog}
        handleOpen={setShowCompleteProfileDialog}
        handleCompleteProfile={() => router.push('/account/complete-profile')}
        handleOnSkipCompleteProfile={handleQuickDeposit}
      />
    </>
  );

  return {
    handleDemoPlay,
    handleRealPlay,
    dialogsRenderer,
    setShowCloseGameDialog,
    handleQuickDeposit,
  };
};

export default useCasinoGameClick;
